import React, { useEffect, useState } from "react";

function getEmbedInfo(url) {
  if (!url) return null;

  // YouTube: youtu.be/xxxx
  let match = url.match(/youtu\.be\/([^?&]+)/);
  if (match) {
    return `https://www.youtube.com/embed/${match[1]}`;
  }

  // YouTube: youtube.com/watch?v=xxxx
  match = url.match(/[?&]v=([^?&]+)/);
  if (match) {
    return `https://www.youtube.com/embed/${match[1]}`;
  }

  // YouTube: already embed
  if (url.includes("youtube.com/embed/")) {
    return url;
  }

  // Twitch: twitch.tv/channelname (channel/live stream)
  match = url.match(/twitch\.tv\/([a-zA-Z0-9_]+)(?:\/)?$/);
  if (match && match[1] !== "videos") {
    const parent = window.location.hostname;
    return `https://player.twitch.tv/?channel=${match[1]}&parent=${parent}`;
  }

  // Twitch: already an embed URL — just make sure parent is set
  if (url.includes("player.twitch.tv")) {
    const parent = window.location.hostname;
    const hasParent = /[?&]parent=/.test(url);
    return hasParent ? url : `${url}${url.includes("?") ? "&" : "?"}parent=${parent}`
  }

  return null;
}

export default function LiveStreamDropdown() {
  const [open, setOpen] = useState(false);
  const [embedInfo, setEmbedInfo] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    async function load() {
      try {
        const res = await fetch("/api/livestream");
        const data = await res.json();
        const streamUrl = data.liveStreamLink;
        if (streamUrl) {
          setEmbedInfo(getEmbedInfo(streamUrl));
        }
      } catch (err) {
        console.error("Failed to load livestream", err);
      }

      setLoaded(true);
    }

    load();
  }, []);

  // don't render until checked
  if (!loaded) return null;

  // no link = no dropdown at all
  if (!embedInfo) return null;

  return (
    <div className={`live-stream ${open ? "open" : ""}`}>
      <button className="live-stream-toggle" onClick={() => setOpen(!open)}>
        <span className="live-label">COMP LIVE STREAM</span>
        <span className={`arrow ${open ? "open" : ""}`}>▼</span>
      </button>
      <div className="live-stream-panel">
        <div className="video-wrapper">
          <iframe
            src={embedInfo}
            title="Live Stream"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
}